import { styled } from '@naan/stitches.config';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import { CompletedCheckmark } from '../components/completed-checkmark';
import { useChapterRowUiContext } from './chapter-row-ui-model';

export const EyeOff = ({ color = 'currentColor' }) => {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45 24C45 35.598 35.598 45 24 45C12.402 45 3 35.598 3 24C3 12.402 12.402 3 24 3C35.598 3 45 12.402 45 24ZM48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM24 17C19.7967 17 15.9849 19.455 13.1721 23.4427C12.9426 23.7694 12.9426 24.2258 13.1721 24.5525C15.9849 28.545 19.7967 31 24 31C28.2033 31 32.0151 28.545 34.8279 24.5573C35.0574 24.2306 35.0574 23.7742 34.8279 23.4475C32.0151 19.455 28.2033 17 24 17ZM24.2607 27.9919C21.8484 28.1436 19.8564 26.1554 20.0081 23.7393C20.1326 21.7473 21.7473 20.1327 23.7393 20.0081C26.1516 19.8564 28.1436 21.8446 27.9919 24.2607C27.8635 26.2488 26.2488 27.8635 24.2607 27.9919Z"
        fill={color}
      />
    </svg>
  );
};

export const EyeOn = ({ color = 'currentColor' }) => {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM24 17C19.7967 17 15.9849 19.455 13.1721 23.4427C12.9426 23.7694 12.9426 24.2258 13.1721 24.5525C15.9849 28.545 19.7967 31 24 31C28.2033 31 32.0151 28.545 34.8279 24.5573C35.0574 24.2306 35.0574 23.7742 34.8279 23.4475C32.0151 19.455 28.2033 17 24 17ZM24.2607 27.9919C21.8484 28.1436 19.8564 26.1554 20.0081 23.7393C20.1326 21.7473 21.7473 20.1327 23.7393 20.0081C26.1516 19.8564 28.1436 21.8446 27.9919 24.2607C27.8635 26.2488 26.2488 27.8635 24.2607 27.9919Z"
        fill={color}
      />
    </svg>
  );
};

export const EarOff = ({ color = 'currentColor' }) => {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45 24C45 35.598 35.598 45 24 45C12.402 45 3 35.598 3 24C3 12.402 12.402 3 24 3C35.598 3 45 12.402 45 24ZM48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM17.75 21.5C17.75 20.4249 18.1886 18.9741 19.1944 17.8006C20.1799 16.6509 21.7234 15.75 24 15.75C26.2361 15.75 27.6449 16.7399 28.5184 17.9411C29.4175 19.1773 29.75 20.6448 29.75 21.5C29.75 22.4279 29.6354 23.1863 29.2579 23.9953C28.8724 24.8213 28.1895 25.7498 26.9697 26.9697C26.7387 27.2006 26.2603 27.8023 25.8292 28.6646C25.7485 28.826 25.6743 29.0138 25.6066 29.1898L25.5526 29.3309L25.5526 29.3309C25.4992 29.4711 25.4451 29.6129 25.3836 29.7639C25.2211 30.1627 25.0281 30.5702 24.7647 30.9391C24.2657 31.6376 23.4835 32.25 22 32.25C19.5679 32.25 18.7528 30.8286 18.6708 30.6646C18.4856 30.2941 18.0351 30.1439 17.6646 30.3292C17.2941 30.5144 17.1439 30.9649 17.3292 31.3354C17.5805 31.8381 18.8321 33.75 22 33.75C24.0165 33.75 25.2343 32.8624 25.9853 31.8109C26.3469 31.3048 26.5914 30.7748 26.7727 30.3298C26.8412 30.1617 26.9037 29.9977 26.9583 29.8545L26.9584 29.8544L27.0066 29.7282C27.0757 29.5487 27.1265 29.424 27.1708 29.3354C27.5397 28.5977 27.9279 28.1327 28.0303 28.0303C29.3105 26.7502 30.1276 25.6787 30.6171 24.6297C31.1146 23.5637 31.25 22.5721 31.25 21.5C31.25 20.3552 30.8325 18.5727 29.7316 17.0589C28.6051 15.5101 26.7639 14.25 24 14.25C21.2766 14.25 19.3201 15.3491 18.0556 16.8244C16.8114 18.2759 16.25 20.0751 16.25 21.5C16.25 21.9142 16.5858 22.25 17 22.25C17.4142 22.25 17.75 21.9142 17.75 21.5ZM24 17.75C23.0999 17.75 22.0509 18.0461 21.2126 18.732C20.3508 19.4371 19.75 20.5252 19.75 22C19.75 23.4905 20.3626 24.4022 20.8455 25.023C20.9123 25.1089 20.9704 25.1823 21.0211 25.2463L21.0211 25.2463C21.1692 25.4334 21.2544 25.541 21.3104 25.6493C21.316 25.6601 21.3202 25.669 21.3233 25.6762C21.0174 26.278 20.4065 26.7082 20.1646 26.8292C19.7941 27.0144 19.6439 27.4649 19.8292 27.8354C20.0144 28.2059 20.4649 28.3561 20.8354 28.1708C21.2586 27.9592 22.1748 27.3275 22.6708 26.3354C22.7869 26.1033 22.8431 25.8558 22.8278 25.5988C22.8129 25.3495 22.7332 25.135 22.6427 24.9601C22.513 24.7093 22.3041 24.4473 22.1362 24.2368L22.1362 24.2368C22.098 24.189 22.062 24.1438 22.0295 24.102C21.6374 23.5978 21.25 23.0095 21.25 22C21.25 20.9748 21.6492 20.3129 22.1624 19.893C22.6991 19.4539 23.4001 19.25 24 19.25C24.5902 19.25 25.1559 19.4476 25.5642 19.8106C25.9588 20.1613 26.25 20.7035 26.25 21.5C26.25 23.1418 25.151 24.086 24.6646 24.3292C24.2941 24.5144 24.1439 24.9649 24.3292 25.3354C24.5144 25.7059 24.9649 25.8561 25.3354 25.6708C26.1823 25.2474 27.75 23.8582 27.75 21.5C27.75 20.2965 27.2912 19.3387 26.5608 18.6894C25.8441 18.0524 24.9098 17.75 24 17.75Z"
        fill={color}
      />
    </svg>
  );
};

export const EarOn = ({ color = 'currentColor' }) => {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM17.75 21.5C17.75 20.4249 18.1886 18.9741 19.1944 17.8006C20.1799 16.6509 21.7234 15.75 24 15.75C26.2361 15.75 27.6449 16.7399 28.5184 17.9411C29.4175 19.1773 29.75 20.6448 29.75 21.5C29.75 22.4279 29.6354 23.1863 29.2579 23.9953C28.8724 24.8213 28.1895 25.7498 26.9697 26.9697C26.7387 27.2006 26.2603 27.8023 25.8292 28.6646C25.7485 28.826 25.6743 29.0138 25.6066 29.1898L25.5526 29.3309L25.5526 29.331C25.4992 29.4711 25.4451 29.6129 25.3836 29.7639C25.2211 30.1627 25.0281 30.5702 24.7647 30.9391C24.2657 31.6376 23.4835 32.25 22 32.25C19.5679 32.25 18.7528 30.8286 18.6708 30.6646C18.4856 30.2941 18.0351 30.1439 17.6646 30.3292C17.2941 30.5144 17.1439 30.9649 17.3292 31.3354C17.5805 31.8381 18.8321 33.75 22 33.75C24.0165 33.75 25.2343 32.8624 25.9853 31.8109C26.3469 31.3048 26.5914 30.7748 26.7727 30.3298C26.8412 30.1617 26.9038 29.9976 26.9584 29.8544L27.0066 29.7282C27.0757 29.5487 27.1265 29.424 27.1708 29.3354C27.5397 28.5977 27.9279 28.1327 28.0303 28.0303C29.3105 26.7502 30.1276 25.6787 30.6171 24.6297C31.1146 23.5637 31.25 22.5721 31.25 21.5C31.25 20.3552 30.8325 18.5727 29.7316 17.0589C28.6051 15.5101 26.7639 14.25 24 14.25C21.2766 14.25 19.3201 15.3491 18.0556 16.8244C16.8114 18.2759 16.25 20.0751 16.25 21.5C16.25 21.9142 16.5858 22.25 17 22.25C17.4142 22.25 17.75 21.9142 17.75 21.5ZM24 17.75C23.0999 17.75 22.0509 18.0461 21.2126 18.732C20.3508 19.4371 19.75 20.5252 19.75 22C19.75 23.4905 20.3626 24.4022 20.8455 25.023C20.9123 25.1089 20.9704 25.1823 21.0211 25.2463L21.0212 25.2464C21.1692 25.4334 21.2544 25.541 21.3104 25.6493C21.316 25.6601 21.3202 25.669 21.3233 25.6762C21.0174 26.278 20.4065 26.7082 20.1646 26.8292C19.7941 27.0144 19.6439 27.4649 19.8292 27.8354C20.0144 28.2059 20.4649 28.3561 20.8354 28.1708C21.2586 27.9592 22.1748 27.3275 22.6708 26.3354C22.7869 26.1033 22.8431 25.8558 22.8278 25.5988C22.8129 25.3495 22.7332 25.135 22.6427 24.9601C22.513 24.7093 22.3041 24.4473 22.1362 24.2368C22.098 24.189 22.062 24.1438 22.0295 24.102C21.6374 23.5978 21.25 23.0095 21.25 22C21.25 20.9748 21.6492 20.3129 22.1624 19.893C22.6991 19.4539 23.4001 19.25 24 19.25C24.5902 19.25 25.1559 19.4476 25.5642 19.8106C25.9588 20.1613 26.25 20.7035 26.25 21.5C26.25 23.1418 25.151 24.086 24.6646 24.3292C24.2941 24.5144 24.1439 24.9649 24.3292 25.3354C24.5144 25.7059 24.9649 25.8561 25.3354 25.6708C26.1823 25.2474 27.75 23.8582 27.75 21.5C27.75 20.2965 27.2912 19.3387 26.5608 18.6894C25.8441 18.0524 24.9098 17.75 24 17.75Z"
        fill={color}
      />
    </svg>
  );
};

export const CheckmarkOff = ({ color = 'currentColor' }) => {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="stage=mark-as-complete, selected=false">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45 24C45 35.598 35.598 45 24 45C12.402 45 3 35.598 3 24C3 12.402 12.402 3 24 3C35.598 3 45 12.402 45 24ZM48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM34 16.8879L31.3038 15L22.179 28.0316L15.8879 23.6265L14 26.3227L22.9873 32.6157L34 16.8879Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const CheckmarkOn = ({ color = 'currentColor' }) => {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM34 16.8879L31.3038 15L22.179 28.0316L15.8879 23.6265L14 26.3227L22.9873 32.6157L34 16.8879Z"
        fill={color}
      />
    </svg>
  );
};

export const chapterStudyIcons = {
  study: {
    on: EyeOn,
    off: EyeOff,
  },
  listen: {
    on: EarOn,
    off: EarOff,
  },
  completed: {
    on: CheckmarkOn,
    off: CheckmarkOff,
  },
};

const Wrapper = styled('div', {
  $$iconSize: '48px',
  $$checkmarkSize: '24px',
  $$checkmarkOffset: '-5px',

  display: 'flex',
  cursor: 'default',
  color: '$black-alpha-70',
  position: 'relative',

  '& .icon svg': {
    width: '$$iconSize',
    height: '$$iconSize',
    transition: 'all 0.2s ease-in-out',
  },

  '& .checkmark': {
    position: 'absolute',
    top: '$$checkmarkOffset',
    right: '$$checkmarkOffset',
    '& svg': {
      width: '$$checkmarkSize',
      height: '$$checkmarkSize',
    },
  },
  '&.compact': {
    $$iconSize: '28px',
    $$checkmarkSize: '14px',
    $$checkmarkOffset: '-3px',
  },
});

export const ChapterStudyButton = observer(
  ({
    mode,
    selected,
    checked,
    compact,
  }: {
    mode: 'study' | 'listen' | 'completed';
    selected: boolean;
    checked: boolean;
    compact: boolean;
  }) => {
    const Icon = chapterStudyIcons[mode][selected ? 'on' : 'off'];
    const chapterUiModel = useChapterRowUiContext();

    return (
      <Wrapper
        className={classNames({ compact })}
        onClick={() => {
          if (chapterUiModel.currentStage === 'study') {
            chapterUiModel.setCurrentStudyMode(mode);
          } else {
            chapterUiModel.setCurrentStage('study');
          }
        }}
      >
        <div className="icon">
          <Icon />
        </div>
        {checked ? (
          <div className="checkmark">
            <CompletedCheckmark />
          </div>
        ) : null}
      </Wrapper>
    );
  }
);
